export class SuspectUser {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly icNumber: string,
    readonly contactNumber: String,
    readonly email: String
  ) {}
}
